// Central config for QLIPPER-WEB. Mirrors member.qlipper.id conventions —
// keep API bases here, do not re-hardcode elsewhere.

export const CONFIG = {
  // NO in-app license gate. Access control is enforced UPSTREAM by Cloudflare
  // Access (only widi.adyatma@gmail.com), so this box stays fully decoupled from
  // prod auth infra (license.qlipper.id) — that's the isolation goal. The app
  // trusts that any request reaching it is already authenticated by Cloudflare.

  // Default Gemini model (never use *-latest — see CLAUDE.md known-patterns).
  // Jul 2026 reality: 3.x GA models on generativelanguage are gemini-3.1-flash-lite /
  // gemini-3.5-flash / gemini-3.1-pro-preview. gemini-2.0-* was SHUT DOWN Jun 1 2026
  // (hard errors now); the 2.5 series retires ~Oct 2026. Pin the cheapest GA 3.x that
  // handles long-transcript JSON well; bump when a newer stable lands.
  GEMINI_MODEL: 'gemini-3.1-flash-lite',
  // Fallback walk order when the pinned/picked model errors at the model level
  // (404 / not found / not supported) — consumed by src/lib/engine/geminiModels.js.
  // Mirrors the desktop app's variant list (app/backend/models/gemini.js).
  GEMINI_FALLBACKS: [
    'gemini-3.1-flash-lite',
    'gemini-3.5-flash',
    'gemini-3.1-flash-lite-preview',
    'gemini-3-flash-preview',
    'gemini-2.5-flash',
    'gemini-2.5-flash-lite',
    'gemma-3-27b-it',
  ],

  // --- Ingestion (3rd-party YouTube download API) ---
  // IMPORTANT: pick a provider that PROXIES the video bytes with CORS headers,
  // not one that returns a raw googlevideo.com link (CORS-blocked). See docs/INGESTION.md.
  YT_API: {
    enabled: false,            // flip true once a CORS-proxying provider is validated
    provider: 'unset',         // 'rapidapi-media-downloader' | 'apify' | 'self-proxy' | ...
    baseUrl: '',               // provider endpoint
    // Whether the download API key is the user's (BYO) or ours (a cost center to meter).
    keyMode: 'byo',            // 'byo' | 'ours'
  },

  // Render engine preference. WebCodecs = hardware-accelerated (fast); ffmpeg.wasm = fallback.
  RENDER: {
    preferred: 'webcodecs',    // 'webcodecs' | 'ffmpeg-wasm'
  },
};
